export default __webpack_public_path__ + "static/media/footer_logo.23d18473.svg";